import { SentimentDissatisfied, SentimentSatisfied, SentimentVeryDissatisfied, SentimentVerySatisfied } from "@mui/icons-material";
import { Rating } from "@mui/material";
import { type IconContainerProps, type RatingProps } from "@mui/material/Rating";
import { styled } from "@mui/material/styles";
import { useFieldValue, useInput, type RaRecord } from "ra-core";
import * as React from "react";

const StyledRating = styled(Rating)(({ theme }) => ({
    "& .MuiRating-iconEmpty .MuiSvgIcon-root": {
        color: theme.palette.action.disabled,
    },
}));

const customIcons: {
    [index: string]: {
        icon: React.ReactElement<unknown>;
        label: string;
    };
} = {
    1: {
        icon: <SentimentVeryDissatisfied sx={{ color: "red" }} />,
        label: "Very Dissatisfied",
    },
    2: {
        icon: <SentimentDissatisfied sx={{ color: "orange" }} />,
        label: "Dissatisfied",
    },
    3: {
        icon: <SentimentSatisfied sx={{ color: "yellow" }} />,
        label: "Satisfied",
    },
    4: {
        icon: <SentimentVerySatisfied sx={{ color: "green" }} />,
        label: "Very Satisfied",
    },
};

function IconContainer(props: IconContainerProps) {
    const { value, ...other } = props;
    return <span {...other}>{customIcons[value]?.icon}</span>;
}

export function SatisfactionInput<T>({ source, ...props }: RatingProps & { source: keyof T }) {
    const { field } = useInput<T>({ source } as any);
    return (
        <StyledRating
            max={4}
            highlightSelectedOnly
            getLabelText={(value: number) => customIcons[value]?.label}
            slotProps={{ icon: { component: IconContainer } }}
            {...props}
            {...field}
        />
    );
}

export function SatisfactionField<T extends RaRecord>({ source, ...props }: RatingProps & { source: keyof T }) {
    const value = useFieldValue<T>({ source } as any);

    return (
        <StyledRating
            disabled
            max={4}
            highlightSelectedOnly
            getLabelText={(value: number) => customIcons[value]?.label}
            slotProps={{ icon: { component: IconContainer } }}
            {...props}
            value={value}
        />
    );
}
